export default function StatsSection() {
  const stats = [
    { value: '5亿+', label: '累计用户', icon: 'ri-user-line' },
    { value: '8000万+', label: '日活用户', icon: 'ri-user-star-line' },
    { value: '300万+', label: '入驻创作者', icon: 'ri-edit-line' },
    { value: '4.9', label: 'App Store评分', icon: 'ri-star-line' },
  ];

  return (
    <section className="py-12 md:py-16 bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            红桃视频平台数据
          </h2>
          <p className="text-sm text-background-50/80 max-w-lg mx-auto">
            用数据说话，红桃视频已成为中国领先的短视频平台之一
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-background-50/15 flex items-center justify-center">
                <i className={`${stat.icon} text-background-50 text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1">{stat.value}</div>
              <div className="text-xs text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}